import React from "react";
import RadioButton from "./RadioButton";
import PercentInput from "./PercentInput";

const MariePercent = ({
  handleMarieChange,
  formErrors,
  otherPercent,
  handleOtherPercentChange,
  onPercentChange,
  validated,
  percent,
}) => {
  return (
    <div
      style={{ backgroundColor: "#f2f3fe", borderRadius: "0.75rem", padding: "2rem" }}
      id="primaireInputField"
    >
      <p style={{ fontSize: "0.875rem", fontWeight: 600, color: "#414751", marginBottom: "0.75rem" }}>
        Choix de congé :
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        <RadioButton
          id="1952"
          value="19.52"
          onChange={handleMarieChange}
          name="congeOption"
          label="1 journée de 4 périodes de 60 minutes d'enseignement et 1 journée de 3 périodes de 60 minutes d'enseignement par 10 jours (19,52%)"
        />
        <RadioButton
          id="1673"
          value="16.73"
          onChange={handleMarieChange}
          name="congeOption"
          label="2 journées de 3 périodes de 60 minutes d'enseignement par 10 jours (16,73%)"
        />
        <RadioButton
          id="MarieAutre"
          name="congeOption"
          value="autre"
          checked={otherPercent}
          onChange={handleOtherPercentChange}
          label="Autre (veuillez indiquer le pourcentage ci-dessous)"
        />
      </div>

      {otherPercent && (
        <div style={{ marginTop: "0.75rem" }}>
          <PercentInput
            value={percent}
            onChange={onPercentChange}
            error={formErrors.percent}
            validated={validated}
          />
        </div>
      )}
      {formErrors.percent && (
        <p style={{ color: "#ba1a1a", fontSize: "0.8rem", marginTop: "0.4rem" }}>
          {formErrors.percent}
        </p>
      )}
    </div>
  );
};

export default MariePercent;
